/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
<template>
  <div id="app">
    <router-view/>
    <img @mousedown="down" @touchstart="down" @mousemove.prevent.stop="move" @touchmove.prevent.stop="move" @mouseup="end" @touchend="end" @click="goHome" v-show="(userType == '1' && $route.name !== 'login' && $route.name !== 'testLogin' && $route.name !== 'selectLogin' && $route.name !== 'accountHome' && $route.name !== 'companyHome' && $route.name !== 'accountMine' && $route.name !== 'taxauth' && $route.name !== 'auth') || (isAccountToCustomer && $route.name !== 'login' && $route.name !== 'testLogin' && $route.name !== 'selectLogin' && $route.name !== 'accountHome' && $route.name !== 'companyHome' && $route.name !== 'accountMine' && $route.name !== 'taxauth' && $route.name !== 'auth')" class="home-icon" src="./assets/images/return-home.png" alt="">
    <img @mousedown="down" @touchstart="down" @mousemove.prevent.stop="move" @touchmove.prevent.stop="move" @mouseup="end" @touchend="end" @click="goCompanyHome" v-show="userType == '2' && $route.name !== 'login' && $route.name !== 'testLogin' && $route.name !== 'selectLogin' && $route.name !== 'companyHome' && $route.name !== 'accountHome' && $route.name !== 'mine' && !isAccountToCustomer && $route.name !== 'taxauth' && $route.name !== 'auth'" class="home-icon" src="./assets/images/return-home.png" alt="">
  </div>
</template>
<script>
import wx from 'weixin-js-sdk'
export default {
  data() {
    return {
      userType: '',
      isAccountToCustomer:false,
      flags: false,
      position: { x: 0, y: 0 },
      nx: '', ny: '', dx: '', dy: '', xPum: '', yPum: '',
    };
  },
  mounted() {
    this.$root.$on("log-record", this.logRecord);
    this.$root.$on("show-homeIcon", this.showHomeIcon);
    this.$root.$on("account-to-customer", this.accountToCustomer);
    console.log('3213', window.location.origin)
    if (process.env.NODE_ENV === 'production' && window.location.origin !== 'https://mock.kdzwy.com') {
      this.$store.dispatch("setTaxUrl", 'https://tax.kdzwy.com');
    } else {
      this.$store.dispatch("setTaxUrl", 'https://mtax.kdzwy.com');
    }
  },
  methods:{
    logRecord(id){
      const userType =  sessionStorage.getItem('userType') || 0;
      this.userType = userType
      const ua = navigator.userAgent.toLowerCase();
      let type;
      if(ua.match(/MicroMessenger/i)=="micromessenger") {
          //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
          wx.miniProgram.getEnv((res)=>{
            if (res.miniprogram) {
                type = 17
            } else {
                type = 18
            }
          })
      }else{
        type = 17
      }
      const params = {
        functionNum:id,
        type:type,
        userType:userType
      }
      this.$http
        .get("/bs/user/zwylog/insert", {
          params: params
        })
        .then(res => {
          console.log(res)
        })
        .catch(error => {
          console.log(error)
        });
    },
    showHomeIcon(userType){
      this.userType = userType
    },
    goHome () {
      this.$router.push({
        name: 'accountHome',
        replace: true
      });
    },
    goCompanyHome () {
      this.$router.push({
        name: 'companyHome',
        replace: true
      });
    },
    accountToCustomer(flag){
      this.isAccountToCustomer = flag
    },
    // 实现移动端拖拽
  down(e){
    let moveDiv = e.target;
    this.flags = true;
    let touch;
    if(event.touches){
        touch = event.touches[0];
    }else {
        touch = event;
    }
    this.position.x = touch.clientX;
    this.position.y = touch.clientY;
    this.dx = moveDiv.offsetLeft;
    this.dy = moveDiv.offsetTop;
  },
  move(e){
    let moveDiv = e.target;
    if(this.flags){
      let touch ;
      if(event.touches){
          touch = event.touches[0];
      }else {
          touch = event;
      }
    
    this.nx = touch.clientX - this.position.x;
    this.ny = touch.clientY - this.position.y;
    this.xPum = this.dx+this.nx;
    this.yPum = this.dy+this.ny;
    //添加限制：只允许在屏幕内拖动
    const maxWidth = document.body.clientWidth - 54;//屏幕宽度减去悬浮框宽高
    const maxHeight = document.body.clientHeight - 54;
    if (this.xPum < 0) { //屏幕x限制
		this.xPum = 0;
    }else if (this.xPum>maxWidth) {
    this.xPum = maxWidth;
    }
    if (this.yPum < 0) { //屏幕y限制
		this.yPum = 0;
    } else if (this.yPum>maxHeight) {
		this.yPum = maxHeight;
    }
      moveDiv.style.left = this.xPum+"px";
      moveDiv.style.top = this.yPum +"px";
      //阻止页面的滑动默认事件
      document.addEventListener("touchmove",function(){ // 1.2 如果碰到滑动问题，请注意是否获取到 touchmove
          event.preventDefault();//jq 阻止冒泡事件
          // event.stopPropagation(); // 如果没有引入jq 就用 stopPropagation()
      },false);
    }
  },
//鼠标释放时候的函数
  end(){
    this.flags = false;
  },
  },
  beforeDestroy(){
    this.$root.$off("log-record");
  }
};
</script>

<style >
@import './common/AlibabaPuHuiTi/alibaba-font.css';
html,
body {
  height: 100%;
}
body {
  background: #f0f2f2;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 0.14rem;
  height: 100%;
}
#app .van-popup--bottom{
  border-radius:6px 6px 0 0;
}
#app .van-tabbar--fixed{
  border-top:1px solid #e6ebf0;
}
[class*=van-hairline]:after{
  border:none;
}
.van-hairline--top-bottom:after{
  border: none;
}
#app .btnRow .van-button--default{
  border: 1px solid #ffffff;
}
#app .btnRow .van-button{
  border-radius: 0;
}
#app .btnRow .van-button--default{
  color: #8896A4;
}
#app .btnRow .van-button--disabled{
  opacity: 1;
}
#app .van-tabs__line{
  border-radius: 0;
}
.text-right {
  text-align: right;
}
.text-center {
  text-align: center;
}
.text-left {
  text-align: left;
}
.van-tabs .van-tabs__line {
  background-color: #1fadf6;
}
.companyHome .van-dropdown-menu {
  /* background-color: rgba(2,175,254,0.7); */
  height: 0.4rem;
}
.companyHome [class*="van-hairline"]::after {
  border: none;
}
.companyHome .van-dropdown-item .van-cell__title {
  -webkit-box-flex: 10;
  -ms-flex: 10;
  flex: 10;
  color: #2c3e50 !important;
}
.companyHome .van-dropdown-item .van-cell--clickable {
  color: #2c3e50;
  text-align: left;
}
.companyHome .van-dropdown-menu__item .van-dropdown-menu__title--active {
  color: #323233 !important;
}
.companyHome .van-dropdown-item .van-icon-success {
  color: #1fadf6 !important;
}
.home-icon {
  position:fixed;
  width: 0.61rem;
  height: 0.61rem;
  bottom: 0.64rem;
  right: 0.03rem;
  z-index: 1999;
}
#app .van-tabs--card{
  padding-top: 0;
}
</style>
